import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const ParallaxImage = ({
  src,
  alt,
  className = "",
  ratio = "aspect-[4/5]",
  speed = 10,
  caption,
  testId,
}) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [`-${speed}%`, `${speed}%`]);

  return (
    <figure ref={ref} className={`relative overflow-hidden ${ratio} ${className}`} data-testid={testId}>
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        style={{ y }}
        className="absolute inset-0 h-full w-full object-cover scale-[1.18]"
      />
      {caption && (
        <figcaption className="absolute bottom-0 left-0 right-0 px-4 py-3 font-mono text-[10px] uppercase tracking-[0.22em] text-cream bg-gradient-to-t from-deep/70 to-transparent">
          {caption}
        </figcaption>
      )}
    </figure>
  );
};
